/* Keep app-rendered product cards canonical too, including PageFly updates. */
(() => {
  const attributes = ['href', 'data-href', 'data-url'];
  const selector = attributes.map(name => `[${name}*="/collections/"]`).join(',');
  const normalize = element => {
    attributes.forEach(name => {
      const value = element.getAttribute(name);
      if (!value || !value.includes('/collections/')) return;
      try {
        const url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin) return;
        const pathname = url.pathname.replace(/\/collections\/[^/]+\/products\//, '/products/');
        if (pathname === url.pathname) return;
        element.setAttribute(name, pathname + url.search + url.hash);
      } catch (_) { /* Non-URL app attributes are left untouched. */ }
    });
  };
  const scan = node => {
    if (node.nodeType !== 1) return;
    if (node.matches(selector)) normalize(node);
    node.querySelectorAll(selector).forEach(normalize);
  };
  scan(document.documentElement);
  new MutationObserver(records => records.forEach(record => {
    if (record.type === 'attributes') normalize(record.target);
    else record.addedNodes.forEach(scan);
  })).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true, attributeFilter: attributes
  });
})();
